module.exports = __webpack_public_path__ + "img/iron_golem_small.f2595f4d.png";